import { DestroyRef, Injectable, inject } from "@angular/core";
import { Observable, Observer, switchMap } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AccountService } from "src/openapi-gen/services";

/**
 * The endpoints this service should be used for do not have a previous request being made 
 * to assign an antiforgery token to the response. In order words an antiforgery token must 
 * be assigned first before the request can be made.
 */
@Injectable({
    providedIn: "root"
})
export class AntiForgeryService {
    private destroyRef = inject(DestroyRef);

    constructor(private accountService: AccountService) {}

    /**
     * Important: Should only be used for entry endpoints which need an initial XSRF token
     * Important: Error handling on this API request is chained into the inner request calling this function
     * Reference: https://stackoverflow.com/questions/73058738/run-multiple-observables-sequentially-and-in-order
     */
    applyAntiForgery = (source: Observable<any>, observerOrNext: Partial<Observer<any>> | ((value: any) => void)): void =>
    {
        this.accountService
            .apiAccountInitRefreshPost()
            .pipe(
                switchMap(_ => source),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(observerOrNext);
    }
}